import React, { useEffect, useState } from 'react';
import './Blog.css';
import { apiGet } from '../api';

const Blog = ({ language = 'ml' }) => {
  const [remotePosts, setRemotePosts] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    let ignore = false;
    (async () => {
      try {
        setLoading(true);
        const resp = await apiGet('/api/posts', { locale: language, isAd: 'false', limit: 12 });
        const arr = Array.isArray(resp?.items) ? resp.items : [];
        if (!ignore) {
          const mapped = arr.map((p) => ({
            id: p.id,
            title: p.title,
            excerpt: p.excerpt || '',
            date: p.date,
            category: p.categoryLabel || (p.category && (p.category.name || p.category.slug)) || 'post',
            image: p.imageUrl || undefined,
            type: p.isAd ? 'ad' : 'post',
            adText: p.adText || undefined,
            ctaText: p.ctaText || undefined,
            slug: p.slug || undefined,
          }));
          setRemotePosts(mapped.filter((m) => m.title));
        }
      } catch (_) {
        // fall back to static content
      } finally {
        setLoading(false);
      }
    })();
    return () => { ignore = true; };
  }, [language]);
  const currentContent = {
    en: { title: 'Latest Blog Posts', subtitle: 'Insights from Homestead Agroecology', readMore: 'Read More' },
    ml: { title: 'പുരയിടകൃഷി ബ്ലോഗ്', subtitle: 'പരമ്പരാഗത ജൈവകൃഷിരീതികൾ, ജൈവവൈവിധ്യം, മണ്ണിന്റെ ആരോഗ്യം, വിത്തുസംരക്ഷണം, കൂടാതെ കാർഷിക മേഖല അഭിമുഖീകരിക്കുന്ന പ്രശ്നങ്ങൾ, പ്രതിസന്ധികൾ, പരിഹാരങ്ങൾ, നയങ്ങൾ അടങ്ങിയ ലേഖനങ്ങൾ', readMore: 'കൂടുതൽ വായിക്കുക' }
  }[language] || { title: 'Latest Blog Posts', subtitle: '', readMore: 'Read More' };
  const postsToShow = remotePosts.slice(0, 6);

  return (
    <section id="blog" className="blog-section">
      <div className="container">
        <div className="blog-header">
          <h2 className="blog-title">{currentContent.title}</h2>
          <p className="blog-subtitle">{currentContent.subtitle}</p>
        </div>

        <div className="blog-grid">
          {postsToShow.map((post) => (
            <article
              key={post.id}
              className={`blog-card ${post.type === 'ad' ? 'blog-card-featured' : ''}`}
            >
              <div className="blog-image">
                <img 
                  src={post.image}
                  alt={post.title}
                  onError={(e) => {
                    e.target.src = `https://via.placeholder.com/400x250/2d5016/ffffff?text=${encodeURIComponent(post.category)}`;
                  }}
                />
                <div className={`blog-category ${post.type === 'ad' ? 'blog-category-featured' : ''}`}>
                  {post.type === 'ad' && post.adText && (
                    <span className="promo-badge">{post.adText}</span>
                  )}
                  {post.category}
                </div>
              </div>
              
              <div className="blog-content">
                {post.type === 'post' && (
                  <div className="blog-meta">
                    <span className="blog-date">{post.date}</span>
                  </div>
                )}
                
                <h3 className="blog-post-title">{post.title}</h3>
                <p className="blog-excerpt">{post.excerpt}</p>
                
                <button
                  className={`blog-read-more ${post.type === 'ad' ? 'blog-cta-button' : ''}`}
                  onClick={() => {
                    if (post.type === 'post' && post.slug) {
                      window.scrollTo(0, 0);
                      window.location.hash = `#/blog/ml/${encodeURIComponent(post.slug)}`;
                    }
                  }}
                >
                  {post.type === 'ad' ? post.ctaText : currentContent.readMore}
                  <svg className="read-more-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="blog-footer">
          <button className="view-all-posts" onClick={() => { window.scrollTo(0, 0); window.location.hash = '#/blog/ml'; }}>
            എല്ലാ ബ്ലോഗ് പോസ്റ്റുകളും കാണുക
          </button>
          {postsToShow.length === 0 && !loading && (
            <div style={{ textAlign: 'center', color: '#6b7280', marginTop: 8 }}>
              {language === 'en' ? 'No posts found.' : 'പോസ്റ്റുകൾ ഒന്നും ലഭ്യമല്ല.'}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Blog;
